import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const EmailBuilderRoutes: Routes = [
  {
    path: "email-builder",
    loadComponent: () =>
      import("./email-builder.component").then((m) => m.EmailBuilderComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./email-templates/email-templates.component").then(
            (m) => m.EmailTemplatesComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./email-template-editor/email-template-editor.component").then(
            (m) => m.EmailTemplateEditorComponent,
          ),
      },
      {
        path: "edit/:id",
        loadComponent: () =>
          import("./email-template-editor/email-template-editor.component").then(
            (m) => m.EmailTemplateEditorComponent,
          ),
      },
    ],
  },
];
